<template>
    <div class="col-md-6 col-lg-3">
        <div class="loader-box" v-if="!Object.keys(campsite).length">
            <ContentLoader class="loader" :height="800" :width="400"
                           :style="{ width: '100%', height: '450px' }"
                           preserveAspectRatio="none">
                <rect x="20" y="20" width="360" height="330"></rect>
                <rect rx="10" ry="10" x="20" y="375" :width="inRange(200, 360)" height="30"></rect>
                <rect rx="10" ry="10" x="20" y="415" :width="inRange(200, 360)" height="20"></rect>
                <rect rx="10" ry="10" x="20" y="440" :width="inRange(200, 360)" height="20"></rect>
                <rect rx="10" ry="10" x="20" y="520" width="150" height="20"></rect>
                <rect rx="10" ry="10" x="350" y="520" width="30" height="20"></rect>
                <rect rx="10" ry="10" x="20" y="560" width="360" height="30"></rect>
                <rect x="20" y="635" width="30" height="30"></rect>
                <rect x="75" y="635" width="30" height="30"></rect>
                <rect x="130" y="635" width="30" height="30"></rect>
                <rect x="185" y="635" width="30" height="30"></rect>
            </ContentLoader>
        </div>
        <div class="listing-box" v-if="Object.keys(campsite).length">
            <div class="listing-box-inner" ref="campsite">
                <router-link :to="`listing/${campsite.id}`" class="listing-box-image">
                    <span v-if="campsite.image" class="listing-box-image-content" :style="`background-image: url(${campsite.image.source})`"></span>
                </router-link>
                <div class="listing-box-content">
                    <h2>
                        <router-link :to="`listing/${campsite.id}`">{{ campsite.campsitename }}</router-link>
                    </h2>
                    <h3>
                        {{ campsite.housenumber }} {{ campsite.street }}<br>
                        {{ campsite.city }}, {{ campsite.country }} {{ campsite.zipcode }}
                    </h3>
                    <div class="actions" v-if="false">
                        <div class="actions-button">
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                        <ul class="actions-list">
                            <li><a href="#">{{ $t('grid_addToCompare') }}</a></li>
                            <li><a href="#">{{ $t('grid_addToFav') }}</a></li>
                            <li><a href="#">{{ $t('grid_reportListing') }}</a></li>
                        </ul>
                    </div>
                </div>
                <div class="listing-box-attributes break-word">
                    <dl>
                        <dt>{{ $t('grid_availablePitches') }}</dt>
                        <dd>{{ campsite.availablepitches }}</dd>
                    </dl>
                    <span>{{campsite.generalinformation}}</span>
                </div>
                <div class="listing-box-attributes-icons">
                    <ul>
                        <li v-for="(characteristic, index) in campsite.characteristicslist" :key="index">
                            <img width="20" height="20" :src="baseURL + characteristic.source" :title="characteristic.hint"/>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: 'CampsiteGridItem',
  components: {ContentLoader},
  props: {
    campsite: {
      required: true,
      type: Object,
    },
  },
  methods: {
    inRange (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
  },
  computed: {
    baseURL: () => window.configECP.baseURL,
  },
}
</script>

<style scoped>
    img {
        display: block;
        width: 20px;
        height: 20px;
        text-indent: -9999px;
    }

    .listing-box-content {
        padding: 12px; /* @TODO: Remove me after 'Add to Fav' introduced */
    }

    .loader-box {
        background-color: #fff;
        box-shadow: 0 1px 1px rgba(50, 50, 50, 0.12);
        border-radius: 2px;
        position: relative;
        z-index: 999;
        height: 388px;
        margin: 0 0 30px 0;
        width: 100%;
    }

    .break-word {
      word-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/components/utilities/CampsiteGridItem.vue